module.exports = __webpack_public_path__ + "static/media/tg-logo.c517bcb7.svg";